import axios from 'axios'
import * as actions from '../../actionTypes'

const GET_CURRENT_SERVICE_AVAILABLE = 'GET_CURRENT_SERVICE_AVAILABLE'
const GET_CURRENT_SERVICE_AVAILABLE_SUCCESS = 'GET_CURRENT_SERVICE_AVAILABLE_SUCCESS'
const GET_CURRENT_SERVICE_AVAILABLE_FAILURE = 'GET_CURRENT_SERVICE_AVAILABLE_FAILURE'

const baseURL = process.env.REACT_APP_SERVICE_URL

const initialState = {
  isServiceAvailable: false,
}
const timeout = process.env.REACT_APP_AXIOS_TIME_OUT
const instance = axios.create({
  timeout: parseInt(timeout),
})

// Reducer

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CURRENT_SERVICE_AVAILABLE_SUCCESS:
      return {
        ...state,
        isServiceAvailable: action.payload.isServiceAvailable,
      }
    case GET_CURRENT_SERVICE_AVAILABLE:
    case GET_CURRENT_SERVICE_AVAILABLE_FAILURE: {
      return initialState
    }
    case actions.CLEAR_ALL: {
      return initialState
    }
    default:
      return state
  }
}

export const getServiceAvailableAction = () => {
  return (dispatch) => {
    dispatch({ type: GET_CURRENT_SERVICE_AVAILABLE })
    return instance.post(`${baseURL}services/fineservice/api/jeinInterfaceUp`).then(
      (response) => {
        if (response.status === 200) {
          dispatch({
            type: GET_CURRENT_SERVICE_AVAILABLE_SUCCESS,
            payload: {
              isTransactionCompleted: response['data'],
            },
          })
          return response
        } else {
          dispatch({ type: GET_CURRENT_SERVICE_AVAILABLE_FAILURE })
        }
      },
      (err) => {
        dispatch({ type: GET_CURRENT_SERVICE_AVAILABLE_FAILURE })
        throw new Error(`Error in get the service available or not`)
      }
    )
  }
}
